export default __webpack_public_path__ + "static/media/email-icon.b33df134.svg";